import { createApi } from '@reduxjs/toolkit/query/react';
import { ReducerPaths } from '../../constants/reducerPaths';
import { baseQuery } from '../../utils/baseQuery';
import { addCertification } from './mutations/add-certification.mutation';
import { updateCertification } from './mutations/update-certification.mutation';
import { deleteCertification } from './mutations/delete-certification.mutation';
import { getCertifications } from './query/get-certifications.query';

export const certificationsApi = createApi({
  reducerPath: ReducerPaths.CANDIDATE_CERTIFICATION,
  baseQuery,
  refetchOnMountOrArgChange: 30,
  refetchOnReconnect: true,
  tagTypes: ['Certification'],
  endpoints: (builder) => ({
    addCertification: addCertification(builder),
    updateCertification: updateCertification(builder),
    deleteCertification: deleteCertification(builder),
    getCertifications: getCertifications(builder),
  }),
});

export const {
  useAddCertificationMutation,
  useUpdateCertificationMutation,
  useDeleteCertificationMutation,
  useGetCertificationsQuery,
} = certificationsApi;
